<template>
  <div class="task-details__wrapper">
    <dl
      v-if="task"
      class="task-details"
    >
      <dt class="typo-small-caption">
        {{ $t('monitoring_plans.instructions') }}
      </dt>
      <dd class="typo-small-title">
        <template v-if="task.instructions">
          {{ task.instructions }}
        </template>
        <span
          v-else
          class="task-details__empty"
        >
          {{ $t('monitoring_plans.no_instructions') }}
        </span>
      </dd>

      <dt class="typo-small-caption">
        {{ $t('monitoring_plans.failure_limit') }}
      </dt>
      <dd class="typo-small-title">
        <template v-if="hasFailureCondition">
          {{ failureLimit }}
        </template>
        <span
          v-else
          class="task-details__empty"
        >
          {{ $t('monitoring_plans.no_failure_limit') }}
        </span>
      </dd>

      <dt class="typo-small-caption">
        {{ $t('monitoring_plans.attachments') }}
      </dt>
      <dd class="typo-small-title">
        <div
          v-if="task.task_documents && task.task_documents.length > 0"
          class="task-details__attachments"
        >
          <a
            v-for="doc in task.task_documents"
            :key="doc.id"
            :href="doc.url"
            target="_blank"
            :title="doc.filename"
          >
            <img
              v-if="doc.preview"
              class="task-details__attachment"
              :src="doc.preview"
            >
            <div
              v-else
              class="task-details__attachment task-details__attachment--document"
            >
              <FileIcon
                class="task-details__attachment-icon"
                :contentType="doc.content_type"
              />
              <span class="task-details__attachment-name typo-tiny">{{ doc.filename }}</span>
            </div>
          </a>
        </div>
        <span
          v-else
          class="task-details__empty"
        >
          {{ $t('monitoring_plans.no_attachments') }}
        </span>
      </dd>
    </dl>
    <Loader
      v-else
      class="task-details__loader"
    />
  </div>
</template>

<script setup>
import { computed, inject } from 'vue';
import I18n from 'i18n-js';

import Loader from '@/components/generic/loader.vue';
import FileIcon from '@/components/generic/file_icon.vue';

defineProps({
  organisationId: { type: String, required: true },
  operationId: { type: String, required: false, default: null },
  equipmentId: { type: String, required: false, default: null },
  planId: { type: String, required: true },
  pointId: { type: String, required: true },
  taskId: { type: String, required: true },
});

/**
 * @constant
 * @type {import('vue').Ref<Object>}
 */
const task = inject('task');

const hasFailureCondition = computed(() => {
  return task.value?.values?.failure_condition;
});

const failureLimit = computed(() => {
  if (!task.value?.values) return '';

  return [
    I18n.t(`failure_conditions.${task.value.values.failure_condition}`),
    task.value.values.failure_value,
    task.value.values.unit,
  ].join(' ');
});
</script>
